import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {
    from: string;
    id: number = -1;
    assignmentId: number;
    hasId: boolean = false;
    name: string = '';
    //accept: boolean = false;
    once: boolean = true;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        location: PlatformLocation
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log('params',params);
            this.from = params['from'];
            this.id = params['id'];
            this.assignmentId = params['assignmentId'];

            this.name = params['name'];

            if ( this.id != -1) {
                this.hasId = true;
            }
        });

        //changing the browser url
        //window.history.pushState({ "html": "", "pageTitle": "" }, "", "app/assessment_instructions");

        //detecting the go back browser button
        location.onPopState(() => {
            console.log('pressed back!');
            if (this.once) {
                setTimeout(() => {
                    this.router.navigate(['/app/client_assessments']);
                }, 100);
                //    window.history.go(-2); 
                this.once = false;
            }
        });
    }

    //acceptInstructions() {
    //    //this.accept = !this.accept;
    //    console.log(this.accept);
    //}

    //showToast() {
    //    this._toastr.warning("Please read all of the instructions for the assessment and select the checkbox.", "ELI");
    //}

    ngOnInit() {
    }

}
